var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    _vm._b(
      {
        staticClass: "table",
        attrs: { data: _vm.dados },
        on: { "sort-change": _vm.sortChanged }
      },
      "el-table",
      _vm.config,
      false
    ),
    [
      _c("template", { slot: "empty" }, [_vm._v("Não há registros.")]),
      _vm.isVtn
        ? _c("el-table-column", {
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm.exibirCheckBox[scope.$index]
                        ? _c("el-checkbox", {
                            ref: "checkBox-" + scope.$index,
                            attrs: {
                              disabled: _vm.listaAtualizada[scope.$index]
                            },
                            on: {
                              change: function($event) {
                                return _vm.selectCheckBox(scope.$index)
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  }
                }
              ],
              null,
              false,
              1832087357
            )
          })
        : _vm._e(),
      _vm._l(_vm.colunas, function(coluna) {
        return _c("el-table-column", {
          key: coluna.label,
          attrs: {
            prop: coluna.prop,
            label: coluna.label,
            width: coluna.width || "auto",
            formatter: coluna.formatter || _vm.Utils.formatEmptyRow,
            sortable: coluna.sortable || false
          }
        })
      }),
      _vm.botoesAcao
        ? _c("el-table-column", {
            attrs: { label: "Ações", width: "120" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm.isOneAction
                        ? _c("el-button", {
                            attrs: { type: "danger", icon: "el-icon-delete" },
                            on: {
                              click: function($event) {
                                return _vm.botoesAcao(scope.row)
                              }
                            }
                          })
                        : _vm._e(),
                      !_vm.isOneAction
                        ? _c("button-acoes", {
                            attrs: { acoes: _vm.botoesAcao(scope.row) }
                          })
                        : _vm._e()
                    ]
                  }
                }
              ],
              null,
              false,
              4242451515
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68f9bb58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f9bb58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableGenerica.vue
// module id = null
// module chunks = 